import React from "react";
import { isBlockActive, toggleBlock, TEXT_ALIGN_TYPES } from "../../utils/slateUtils";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";



const formatMap = {
  "align-left": "left",
  "align-center": "center",
  "align-right": "right",
  "align-justify": "justify",
  "numbered-list": "numbered-list",
  "unordered-list": "bulleted-list",
  "blockquote": "block-quote",
  "code-block": "code-block",
  "undo":"undo",
  "redo":"redo"
};

export const BlockButton = ({ color, editor, format, icon, disabled }) => {
  const blockType = formatMap[format];
  const isAlign = TEXT_ALIGN_TYPES.includes(blockType);
  const active = isBlockActive(editor, blockType, isAlign ? "align" : "type");
  const iconMap = {
    "align-left": <KoIcon width={20} height={20} color={color} name="LeftOutlined" />,
    "align-center": <KoIcon width={20} height={20} color={color}  name="CenterOutlined" />,
    "align-right": <KoIcon width={20} height={20} color={color}  name="RightOutlined" />,
    "align-justify": <KoIcon width={20} height={20} color={color}  name="JustifyOutlined" />,
    "ordered-list": <KoIcon width={20} height={20} color={color}  name="NumberedOutlined" />,
    "unordered-list": <KoIcon width={20} height={20} color={color}  name="BulletOutlined" />,
    "blockquote": <KoIcon width={20} height={20} color={color}  name="DoubleQuotesOutlined" />,
    "code-block": <KoIcon width={20} height={20} color={color}  name="CodeOutlined" />,
    "redo": <KoIcon width={20} height={20} color={color}  name="RedoOutlined" />,
    "undo": <KoIcon width={20} height={20} color={color}  name="UndoOutlined" />
  };
  return (
    <KoButton
      type="text"
      iconBtn
      disabled={disabled}
      icon={iconMap[icon]}
      active={active}
      onClick={(e) => { e.preventDefault(); toggleBlock(editor, blockType); }}
    />
    
  );
};
